import schemas from 'src/modules/shared/yup/yupImporterSchemas';
import { i18n } from 'src/i18n';

export default [
  {
    name: 'regionName',
    label: i18n('entities.region.fields.regionName'),
    schema: schemas.string(
      i18n('entities.region.fields.regionName'),
      {
        "required": true
      },
    ),
  },
  {
    name: 'regionCode',
    label: i18n('entities.region.fields.regionCode'),
    schema: schemas.string(
      i18n('entities.region.fields.regionCode'),
      {},
    ),
  },
  {
    name: 'countries',
    label: i18n('entities.region.fields.countries'),
    schema: schemas.stringArray(
      i18n('entities.region.fields.countries'),
      {},
    ),
  },
];